export default function SFile({ size = 20, className = "", ...props }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="1.5 3 17 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M5.00016 18.3332C4.54183 18.3332 4.15016 18.1665 3.82516 17.8415C3.50016 17.5165 3.3335 17.1248 3.3335 16.6665V3.33317C3.3335 2.87484 3.50016 2.48317 3.82516 2.15817C4.15016 1.83317 4.54183 1.6665 5.00016 1.6665H11.6668L16.6668 6.6665V16.6665C16.6668 17.1248 16.5002 17.5165 16.1752 17.8415C15.8502 18.1665 15.4585 18.3332 15.0002 18.3332H5.00016ZM10.8335 7.49984H15.0002L10.8335 3.33317V7.49984Z"
                fill="currentColor"
            />
        </svg>

    )
}